import React from 'react';
import times from 'lodash/times';
import { Shimmer } from '../../../CommonComponents/OPL/Shimmer/Shimmer';
import { List, ListDefinition, ListHeader, ListTerm } from './EstatePlanningWorkflowReview.styles';

export const EstatePlanningWorkflowReviewLoading = () => {
  return (
    <>
      <ListHeader>
        <Shimmer width={200} height={32} />
      </ListHeader>

      <List>
        {times(5).map(key => (
          <React.Fragment key={key}>
            <ListTerm>
              <Shimmer width={200} height={24} />
            </ListTerm>

            <ListDefinition>
              <Shimmer width={200} height={24} />
            </ListDefinition>
          </React.Fragment>
        ))}
      </List>
    </>
  );
};
